export enum SubmittalStatusEnum {
    PendingAMReview = 1,
    PendingInformation = 2,
    Queued = 3,
    SendToClinical = 4,
    SentToClient = 5,
    UnderReviewByHiringManager = 6,
    AdditionalReviewNeeded = 7,
    CandidateNotSelected = 8,
    CandidateWithdrawingFromSubmission = 9,
    Interview = 10,
    Offer = 11,
    OfferVerballyAccepted = 12,
    OfferDeclined = 13,
    Placed = 14,
    OfferRescinded = 15,
    Canceled = 16,
    OfferAccepted = 17,
    ClinicalPassed = 18,
    ClinicalScreened = 19,
    ClinicalDeclined = 20,
    ClinicalRedirect = 21,
    NameClear = 22,
    Draft = 23
}

export enum ResumeSubmitStatusEnum {
    Draft = -999,
    Active = 1,
    InActive = 0,
    Unknown = -1
}

export type SubmittalSubStatusEnum =
    | SubmittalInterviewSubStatusEnum
    | SubmittalOfferSubStatusEnum
    | CandidateNotSelectedEnum
    | CandidateWithdrawingFromSubmissionEnum;

export enum SubmittalInterviewSubStatusEnum {
    Requested = 10,
    Scheduled = 11,
    CompletedPendingDecision = 12
}

export enum SubmittalOfferSubStatusEnum {
    Pending = 16,
    Extended = 17
}

export enum CandidateNotSelectedEnum {
    NotEnoughRelevantExperience = 1,
    LicensingCertRequirementNotMet = 2,
    EducationRequirementNotMet = 3,
    FacilityVaccinationPolicyNotMet = 4,
    StartDateCouldNotBeAccommodated = 5,
    RtoScheduleRequestsCouldNotBeAccommodated = 6,
    CandidateCouldNotBeReachedForInterview = 7,
    IncompleteProfile = 18,
    FacilityRequirementsNotMet = 19,
    FacilityDeclined = 20,
    JobFilled = 21,
    JobOnHold = 22,
    DuplicateSubmittal = 23,
    Other = 26,
    MileageRestriction = 29,
    PleaseCallYourDeliveryManagerForDetails = 30,
    JobRemoved = 31
}

export enum CandidateWithdrawingFromSubmissionEnum {
    CandidateAcceptedAnOfferElsewhere = 8,
    CandidateDeclinedToMoveForward = 9,
    OfferDeclined = 25,
    AlreadySubmittedByAnotherAgency = 27,
    DifferentLocationPreferred = 28
}

export const submittalStatusesWithAutoRemoval = [
    SubmittalStatusEnum.CandidateNotSelected,
    SubmittalStatusEnum.CandidateWithdrawingFromSubmission,
    SubmittalStatusEnum.Placed
];

export const submittalStatusesWithDraft = [SubmittalStatusEnum.Draft];

export const submittalStatusesWithProcessing = [
    SubmittalStatusEnum.PendingAMReview,
    SubmittalStatusEnum.PendingInformation,
    SubmittalStatusEnum.Queued,
    SubmittalStatusEnum.SentToClient,
    SubmittalStatusEnum.SendToClinical,
    SubmittalStatusEnum.ClinicalPassed,
    SubmittalStatusEnum.ClinicalScreened,
    SubmittalStatusEnum.ClinicalDeclined,
    SubmittalStatusEnum.ClinicalRedirect
];
